import React, {useEffect} from 'react'
import Footer from '../components/Footer';
import Header from '../pages/Home/components/Header'
import LoggedInUserHeader from '../components/Header/LoggedInUserHeader'
import {useSelector} from 'react-redux';
import { animateScroll } from 'react-scroll';


const TermsConditions = () => {
    const isAuthenticated = useSelector(
        (state) => state.basicInfo.isAuthenticated
    );

    useEffect(()=>{
        animateScroll.scrollToTop({ duration: 300 });
    },[])

    return (
        <div className="clint-body privacy-policy-page">
            <div>
                {
                    isAuthenticated ?
                    <LoggedInUserHeader/> :
                    <Header/> 
                }



            <section className="transaction-history">
                <div className="container theme-section">
                    <h1 className="tr-title text-center"> Terms & Conditions </h1>
                    
                    <div className='privacy-content'>

                        <b>Effective Date: 01/01/2025</b>

                        <br/>
                        <br/>

                        <p>Welcome to the Poncore Dispatch Marketplace, a product of Padmore Global Connections (PGC). By accessing or using our website https://www.poncore.com ("the Site"), you agree to comply with and be bound by the following terms and conditions ("Terms"). If you do not agree with these Terms, you must not use our services.</p>

                        <br/>
                        <br/>
                    

                        <b>1. Acceptance of Terms</b> 
                        <br/>
                        By accessing or using the Poncore Dispatch Marketplace platform, you agree to these Terms and Conditions, including any future amendments. PGC reserves the right to update, modify, or revise these Terms at any time, and your continued use of the Site after any such changes will constitute your acceptance of the revised Terms.

                        <br/>   
                        <br/>

                        <b>2. User Eligibility</b> 
                        <br/>
                        To use the Poncore Dispatch Marketplace, you must be at least 18 years old and have the legal capacity to enter into contracts. By using this platform, you represent and warrant that you meet these eligibility requirements.

                        <br/>   
                        <br/>

                        <b>3. Account Registration</b> 
                        <br/>
                        In order to access certain features of the Poncore Dispatch Marketplace, you may be required to create an account. When registering, you agree to:
                        <br/>

                        <ul>
                            <li> 
                                <b>.</b> Provide accurate, current, and complete information about yourself as requested by the registration forms.
                            </li>
                            <li>
                                <b>.</b> Maintain the confidentiality of your account credentials and promptly notify us of any unauthorized use of your account.
                            </li>
                            <li>
                                <b>.</b> Be solely responsible for any activities under your account, whether authorized or not.
                            </li>
                        </ul>


                        <br/>
                        <br/>

                        <b>4. Use of the Platform</b> 
                        <br/>
                        You agree to use the Poncore Dispatch Marketplace for lawful purposes only and in accordance with these Terms. You shall not:
                        <br/>

                        <ul>
                            <li> 
                                <b>.</b> Use the platform for any illegal or unauthorized purposes.

                            </li>
                            <li>
                                <b>.</b> Engage in any activity that could harm, disable, or overburden the platform, including the use of automated systems or data scraping techniques.
                            </li>
                            <li>
                                <b>.</b> Upload or transmit any viruses, malware, or harmful code that could disrupt or damage the functionality of the Site.
                            </li>
                            <li>
                                <b>.</b> Attempt to gain unauthorized access to any part of the Site, other users' accounts, or the underlying systems or networks.
                            </li>
                        </ul>

                        <br/>
                        <br/>

                        <b>5. Transactions and Payment</b> 
                        <br/>
                        The Poncore Dispatch Marketplace allows users to connect for transportation transactions. By using the platform, you agree to:
                        <br/>

                        <ul>
                            <li> 
                                <b>.</b> Provide accurate and complete details for the loads you are transporting or receiving.
                            </li>
                            <li>
                                <b>.</b> Make timely payments for any services and transactions conducted through the platform.
                            </li>
                            <li>
                                <b>.</b> Abide by the terms and conditions established by any third-party payment processors involved in your transactions.
                            </li>
                        </ul>

                        <br/>

                        <b>6. Fees</b> 
                        <br/>
                        
                        Poncore Dispatch Marketplace does not charge membership or subscription fees. However, you may incur charges for certain services or transactions conducted through the platform. These charges will be clearly outlined at the time of the transaction. All payments are subject to applicable taxes and other charges, as required by law.

                        <br/>
                        <br/>

                        <b>7. Intellectual Property</b> 
                        <br/>
                        
                        All content on the Poncore Dispatch Marketplace, including but not limited to text, graphics, logos, images, and software, is the property of PGC or its licensors and is protected by intellectual property laws. You may not use, reproduce, distribute, or modify any content from the platform without the express written consent of PGC.

                        <br/>
                        <br/>

                        <b>8. Privacy and Data Protection</b> 
                        <br/>
                        
                        Your use of the Poncore Dispatch Marketplace is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information. By using the platform, you consent to the collection and use of your data as outlined in the Privacy Policy.

                        <br/>
                        <br/>

                        <b>9. Disclaimer of Warranties</b> 
                        <br/>
                        
                        The Poncore Dispatch Marketplace is provided "as is" and "as available" without warranties of any kind, whether express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, or non-infringement. PGC does not warrant that the platform will be uninterrupted, error-free, or free from viruses or other harmful components.

                        <br/>
                        <br/>

                        <b>10. Limitation of Liability</b> 
                        <br/>
                        
                        To the fullest extent permitted by law, PGC shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the Poncore Dispatch Marketplace, including any errors or omissions in the content, loss of data, or any transactions made through the platform.

                        <br/>
                        <br/>

                        <b>11. Indemnification</b> 
                        <br/>
                        You agree to indemnify, defend, and hold harmless PGC, its officers, directors, employees, agents, and affiliates from and against any claims, losses, liabilities, damages, and expenses (including legal fees) arising from:
                        <br/>

                        <ul>
                            <li> 
                                <b>.</b> Your use of the Poncore Dispatch Marketplace.
                            </li>
                            <li>
                                <b>.</b> Any violation of these Terms.
                            </li>
                            <li>
                                <b>.</b> Any unlawful conduct or infringement of the rights of third parties.
                            </li>
                        </ul>

                        <br/>

                        <b>12. Termination</b> 
                        <br/>
                        
                        PGC reserves the right to suspend or terminate your account and access to the Poncore Dispatch Marketplace at its sole discretion if you violate these Terms or engage in conduct that we believe may harm PGC or other users. Upon termination, you must cease all use of the platform and its services.

                        <br/>
                        <br/>

                        <b>13. Governing Law</b> 
                        <br/>
                        
                        These Terms shall be governed by and construed in accordance with the laws of the United States and Ghana, as applicable. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the competent courts in the United States or Ghana, depending on your location.

                        <br/>
                        <br/>

                        <b>14. Dispute Resolution</b> 
                        <br/>
                        
                        In the event of any dispute, claim, or controversy arising out of or relating to these Terms or the use of the Poncore Dispatch Marketplace, the parties shall first attempt to resolve the matter through informal negotiation. If the dispute is not resolved, it shall be subject to arbitration in accordance with the rules of [Arbitration Organization] in the jurisdiction where the dispute arises.

                        <br/>
                        <br/>

                        <b>15. Severability</b> 
                        <br/>
                        
                        If any provision of these Terms is found to be unlawful, void, or unenforceable, the remaining provisions will remain in full effect.

                        <br/>
                        <br/>

                        <b>16. Entire Agreement</b> 
                        <br/>
                        
                        These Terms represent the complete and exclusive agreement between you and PGC regarding the use of the Poncore Dispatch Marketplace, superseding all prior or contemporaneous agreements, communications, and proposals, whether written or oral.

                        <br/>
                        <br/>

                        <b>17. Contact Us</b> 
                        <br/>
                        
                        <p>If you have any questions or concerns about this Privacy Policy, or if you wish to exercise your privacy rights, please contact us:</p>

                        <b>Padmore Global Connections</b>
                        <p>Attn: Poncore Dispatch Marketplace - Terms and Conditions</p>
                        <p>Email: padmore.ayim@pgc-connect.com</p>
                        <p>Phone: 240-478-2730</p>
                        <p>Address: 1481 Osage Road, North Brunswick, NJ 08902</p>

                        <br/>
                        <br/>

                    </div>
                </div>
            </section>
            </div>
            <Footer/>
        </div>
    )
}

export default TermsConditions
